export class ProductionOrderProducts{
  productos:any[];

  constructor(productos){
    this.productos = [];
    if(productos.length != 0){
      for(let i=0;i<productos.value.length;i++){
        this.productos.push({'id':productos.value[i].id,'cajas':productos.value[i].cajas});
      }
    }
  }


  public getJson(){
    let coma =',';
    let esp = '';
    for(let i=0;i < this.productos.length;i++){
      if((i+1) === this.productos.length){
        coma = '';
      }
      esp += `{"type":"production_orders_products","product_id":"${this.productos[i].id}","quantity":${this.productos[i].cajas},"user_id":1}${coma}`;
    }

    return `{"data":[${esp}]}`;

  }

  public getJson2(productos,cantidad,usuario){
    let coma =',';
    let esp = '';

    for(let i=0;i < productos.length;i++){
      if((i+1) === productos.length){
        coma = '';
      }
      esp += `{"type":"production_orders_products","product_id":"${productos[i].id}","quantity":${cantidad},"user_id":${usuario}}${coma}`;
    }

    return `{"data":[${esp}]}`;

  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/ProductionOrdersProducts.ts